"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppSettingsContext = void 0;
const react_1 = require("react");
const lodash_1 = require("lodash");
exports.AppSettingsContext = react_1.createContext({
    init: lodash_1.noop,
    update: () => Promise.resolve(),
    settings: {},
});
//# sourceMappingURL=app-settings-context.js.map